<template>
  <section class="my-30">
      <Container>
        <SectionHeader>Floorplan</SectionHeader>
        <div>
          <viewer
            :options="options"
            :images="images"
            @inited="inited"
            ref="viewer"
            class="grid sm:grid-cols-2 gap-8"
          >
            <template slot-scope="scope">
              <div
                class="w-full h-[420px] group relative cursor-pointer"
                v-for="({ source, thumbnail }, index) in scope.images"
                :key="index"
              >
                <img
                  class="w-full h-full object-cover transition-opacity duration-300"
                  :src="thumbnail"
                  :data-source="source"
                />
                <div
                  class="absolute inset-0 flex justify-center items-center opacity-0 transition-opacity duration-200 group-hover:opacity-85 pointer-events-none"
                  :class="{
                    'bg-primary-color': !getPrimaryColor,
                    [`bg-[${getPrimaryColor}]`]: getPrimaryColor
                  }"
                >
                <div class="relative z-50 translate-y-10 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <img :src="zoom" alt="zoom" />
                </div>
                </div>
                <slot />
              </div>
            </template>
          </viewer>
        </div>

        <div class="flex flex-wrap gap-10 mt-14">
          <a
            v-for="(plan, index) in getFloorplanFiles"
            :key="plan"
            :href="plan"
            target="_blank"
            class="flex gap-4 items-center hover:underline!"
          >
            <FontAwesomeIcon 
              icon="file-pdf" 
              size="lg"
              :class="{
                'text-primary-color': !getPrimaryColor,
                [`text-[${getPrimaryColor}]`]: getPrimaryColor
              }"
            />
            <span class="text-secondary-color text-base">Document {{ index + 1 }}</span>
          </a>
        </div>
      </Container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Vue from 'vue'
  import VueViewer from 'v-viewer';

  import 'viewerjs/dist/viewer.css';

  import SectionHeader from '../../components/SectionHeader';
  import Container from '../../components/Container';
  import zoom from '../Gallery/components/zoom.png';

  Vue.use(VueViewer);

  export default {
    name: 'Floorplan',
    components: {
      SectionHeader,
      Container
    },
    data () {
      return {
        options: {
          url: 'data-source',
          zIndex: 9999
        },
        zoom
      }
    },
    computed: {
      ...mapGetters('tour', ['getFloorplanPhotos', 'getFloorplanFiles', 'getPrimaryColor']),
      images () {
        return this.getFloorplanPhotos.map(item => ({
          thumbnail: item.xl,
          source: item.original
        }));
      }
    },
    methods: {
      inited (viewer) {
        this.$viewer = viewer;
      }
    }
  };
</script>

<style lang="scss">
  .viewer-backdrop {
    background-color: rgba(0, 0, 0, 80%);
  }
</style>
